// extracted by mini-css-extract-plugin
module.exports = {"svg":"cloud-three_svg__k6zCR"};